import { useTranslation } from "react-i18next";
import { useChangedDialog } from "../../hooks/useChangedDialog";
import EColourPanel from "../../interfaces/EColourPanel";
import DynamicForm from "../../yoello-lib/modules/dynamicForms/DynamicForms";
import { usePrinterDialog } from "./usePrinterDialog";
import { IMultiDialogChildren } from "../dialogRoutes/MultiDialogRoute";
import { ICallAPIFunction } from "../../yoello-lib/modules/API2/types";
import { IListItem, IPrinterFormState } from "./types";
import { FormLoadingWrapper } from "../util/FormLoadingWrapper";
import ListLoading from "../util/Loading";

export interface IPrintersDialog extends IMultiDialogChildren {
  printerCallApi:ICallAPIFunction<IListItem[] | IListItem>;
  printer:IListItem;
  path: string;
  itemData?:IPrinterFormState;
  formState?:IPrinterFormState;
}

export function PrintersDialog(props: IPrintersDialog) {
  const { t } = useTranslation();
  const { hasFormChanged } = useChangedDialog();
  
  const {formData, formRows, onSubmit, isSettingUp, isLoading} = usePrinterDialog(props);

  return (!formRows || !formData || isSettingUp || isLoading  ? <FormLoadingWrapper><ListLoading/></FormLoadingWrapper> :
    <DynamicForm
      useFormOptions={{
        mode: "onChange", reValidateMode: "onChange"
      }}
      onHandleSubmit={onSubmit}
      formRows={formRows}
      formData={formData}
      disableAll={false}
      formKeyName={"Printers"}
      isDialog={true}
      hasDataChanged={hasFormChanged}
      formButtons={{
        leftButton: {
          type: "button",
          label: t("forms.buttons.cancel"),
          color: EColourPanel.DEFAULT,
          fullWidth: false,
          onClick: props.onClose,
        },
        rightButton: {
          type: "submit",
          label: t("discounts.buttons.createDiscount"),
          color: EColourPanel.PRIMARY,
          fullWidth: false,
          disabled: isLoading,
        },
      }}
    />
  )
}
